(function () {
  function pushVideoEvent(status, percent, provider, title) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'video_engagement',
      video_status: status,
      video_percent: percent,
      video_provider: provider,
      video_title: title || '',
    });
  }

  // --- Native <video> tracking ---
  var trackedNative = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var trackedNativeArr = [];

  function isNativeTracked(video) {
    return trackedNative ? trackedNative.has(video) : trackedNativeArr.indexOf(video) !== -1;
  }

  function markNativeTracked(video) {
    if (trackedNative) {
      trackedNative.add(video);
    } else {
      trackedNativeArr.push(video);
    }
  }

  function getNativeVideoTitle(video) {
    var source = video.querySelector('source');
    return video.currentSrc || (source && (source.src || source.getAttribute('data-src'))) || '';
  }

  function trackNativeVideo(video) {
    if (isNativeTracked(video)) return;
    markNativeTracked(video);

    var firedThresholds = {};
    var title = getNativeVideoTitle(video);

    video.addEventListener('play', function () {
      pushVideoEvent('start', 0, 'native', title);
    });

    video.addEventListener('timeupdate', function () {
      if (!video.duration) return;
      var percent = Math.floor((video.currentTime / video.duration) * 100);
      [25, 50, 75, 90].forEach(function (threshold) {
        if (percent >= threshold && !firedThresholds[threshold]) {
          firedThresholds[threshold] = true;
          pushVideoEvent('progress', threshold, 'native', title);
        }
      });
    });

    video.addEventListener('ended', function () {
      pushVideoEvent('complete', 100, 'native', title);
    });
  }

  function scanNativeVideos(root) {
    if (!root.querySelectorAll) return;
    var videos = root.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) {
      trackNativeVideo(videos[i]);
    }
  }

  // --- YouTube iframe tracking ---
  var trackedYouTube = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var trackedYouTubeArr = [];
  var youTubeApiLoading = false;
  var youTubeApiReadyCallbacks = [];

  function isYouTubeTracked(iframe) {
    return trackedYouTube ? trackedYouTube.has(iframe) : trackedYouTubeArr.indexOf(iframe) !== -1;
  }

  function markYouTubeTracked(iframe) {
    if (trackedYouTube) {
      trackedYouTube.add(iframe);
    } else {
      trackedYouTubeArr.push(iframe);
    }
  }

  function ensureYouTubeApi(callback) {
    if (window.YT && window.YT.Player) {
      callback();
      return;
    }
    youTubeApiReadyCallbacks.push(callback);
    if (youTubeApiLoading) return;
    youTubeApiLoading = true;

    var previousReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof previousReady === 'function') previousReady();
      youTubeApiReadyCallbacks.forEach(function (cb) {
        cb();
      });
      youTubeApiReadyCallbacks = [];
    };

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }

  function trackYouTubeIframe(iframe) {
    if (isYouTubeTracked(iframe)) return;
    if (!iframe.src || iframe.src.indexOf('youtube.com/embed') === -1) return;
    markYouTubeTracked(iframe);

    if (iframe.src.indexOf('enablejsapi=1') === -1) {
      iframe.src += (iframe.src.indexOf('?') !== -1 ? '&' : '?') + 'enablejsapi=1';
    }
    if (!iframe.id) {
      iframe.id = 'yt-tracked-' + Math.random().toString(36).slice(2);
    }

    ensureYouTubeApi(function () {
      var firedThresholds = {};
      var progressTimer = null;

      new window.YT.Player(iframe.id, {
        events: {
          onStateChange: function (e) {
            var videoData = e.target.getVideoData ? e.target.getVideoData() : {};
            var title = videoData && videoData.title ? videoData.title : '';

            if (e.data === window.YT.PlayerState.PLAYING) {
              pushVideoEvent('start', 0, 'youtube', title);
              if (progressTimer) clearInterval(progressTimer);
              progressTimer = setInterval(function () {
                var duration = e.target.getDuration();
                if (!duration) return;
                var percent = Math.floor((e.target.getCurrentTime() / duration) * 100);
                [25, 50, 75, 90].forEach(function (threshold) {
                  if (percent >= threshold && !firedThresholds[threshold]) {
                    firedThresholds[threshold] = true;
                    pushVideoEvent('progress', threshold, 'youtube', title);
                  }
                });
              }, 1000);
            } else if (e.data === window.YT.PlayerState.ENDED) {
              if (progressTimer) clearInterval(progressTimer);
              pushVideoEvent('complete', 100, 'youtube', title);
            } else if (e.data === window.YT.PlayerState.PAUSED) {
              if (progressTimer) clearInterval(progressTimer);
            }
          },
        },
      });
    });
  }

  function scanYouTubeIframes(root) {
    if (!root.querySelectorAll) return;
    var iframes = root.querySelectorAll('iframe[src*="youtube.com/embed"]');
    for (var i = 0; i < iframes.length; i++) {
      trackYouTubeIframe(iframes[i]);
    }
  }

  function scanForVideos(root) {
    scanNativeVideos(root);
    scanYouTubeIframes(root);
  }

  function init() {
    scanForVideos(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          var node = mutation.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'VIDEO') {
            trackNativeVideo(node);
          } else if (node.tagName === 'IFRAME') {
            trackYouTubeIframe(node);
          } else {
            scanForVideos(node);
          }
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
